export interface SectionListProps {
  onPress: () => void
  apply: () => void
  updateMin: (data: string) => void
  updateMax: (data: string) => void
  selectedFilteredData: any
  updateFilters: (mode: filterTypes, value: string) => void
  checkSelected: (mode: filterTypes, value: string) => boolean
  updateFilterSettings: (data: any) => void
  filterData: any
  filterHeader: any
  filtersStrings: any
  updateDate?: any
  selectedDateInfo?: any
  clearFilters?: any
}

export const sectionVisible = {
  payMethods: '1',
  status: '2',
  amount: '3',
  date: '4',
  none: '0',
}

export enum filterTypes {
  transactionStatus = 'transactionStatus',
  paymentMode = 'paymentMode',
}
export interface FilterItemProps {
  mode: filterTypes
  updateFilters: (mode: filterTypes, value: string) => void
  checkSelected: (mode: filterTypes, value: string) => boolean
  header: string
  filterData: any
  show: boolean
}
